import { Component, Fragment } from 'react';

import ViewableElement from '../modules/ViewableElement';
import { ViewableElementWrapper } from '../modules/ViewableElementWrapper';

interface IProps {
  isAuthorCommentModule: boolean;
  authorName?: string;
  authorThumbUrl?: string;
  authorTitle?: string;
  commentText?: string;
  commentViewablePos: number;
}

export default class FeedArticleComment extends Component<IProps> {
  /**
   *
   */
  public render() {
    // オーサーコメント
    const AuthorLabel = this.props.isAuthorCommentModule ? (
      <Fragment>
        <p className="newsFeed_comment_label">オーサーコメント</p>
        <dl className="newsFeed_comment_author">
          <dt className="newsFeed_comment_authorName">{this.props.authorName}</dt>
          <dd className="newsFeed_comment_authorDescription">{this.props.authorTitle}</dd>
        </dl>
      </Fragment>
    ) : null;

    return (
      <ViewableElementWrapper className="newsFeed_comment">
        <img src={this.props.authorThumbUrl} className="newsFeed_comment_thumbnail" />
        <div className="newsFeed_comment_wrap">
          {AuthorLabel}
          <p className="newsFeed_comment_text">{this.props.commentText}</p>
        </div>
        <ViewableElement
          id={`viewable_newsFeed_comment_bottom_${this.props.commentViewablePos}`}
          position="bottom"
          dataClParams={`_cl_vmodule:v_tlcmt;_cl_link:stream;_cl_position:${this.props.commentViewablePos};`}
        />
      </ViewableElementWrapper>
    );
  }
}
